import { render, staticRenderFns } from "./CurrentAddress.vue?vue&type=template&id=f5aea7d6&scoped=true&"
import script from "./CurrentAddress.vue?vue&type=script&lang=js&"
export * from "./CurrentAddress.vue?vue&type=script&lang=js&"
import style0 from "./CurrentAddress.vue?vue&type=style&index=0&id=f5aea7d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aea7d6",
  null
  
)

export default component.exports